import { AxiosResponse } from 'axios';
import { REASON_TYPE } from '../../../constants';
import api from '../../../services/api';

class ReasonService {
  getAll() {
    return api.get('/reason/');
  }
  getReason(id: any) {
    return api.get(`/reason/${id}`);
  }
  deleteReason(id: any) {
    return api.delete(`/reason/${id}`);
  }
  createReason(payload: any): Promise<AxiosResponse<any | null>> {
    return api.post('/reason/', payload);
  }
  editReason(payload: any): Promise<AxiosResponse<any | null>> {
    return api.put('/reason/', payload);
  }

  parseType(type: string) {
    switch (type) {
      case REASON_TYPE.CLIENTE_BLOCK:
        return 'Cliente bloqueado';

      case REASON_TYPE.NON_PAYMENT:
        return 'Inadimplência';

      case REASON_TYPE.CREDIT_EXCEEDED:
        return 'Limite de crédito excedido';

      case REASON_TYPE.BONIFICATION:
        return 'Bonificação';

      case REASON_TYPE.NON_POSITIVATION:
        return 'Não positivação';

      case REASON_TYPE.NON_SALE:
        return 'Não venda';

      case REASON_TYPE.NON_VISIT:
        return 'Não visita';

      case REASON_TYPE.VISIT_DATE:
        return 'Data de visita';

      case REASON_TYPE.SALES_RESTRICTION:
        return 'Restrição de venda';

      case REASON_TYPE.CLIENT_REGULATION:
        return 'Alvará de produto';

      default:
        return '-';
    }
  }
}

export default new ReasonService();
